import { NpaDropdownConfig } from '@circe/dropdown';
import { NpaActionConfigSource, NpaTableActionsConfigurationModel, NpaTableActionType } from '../table.types';
import { NpaActionConfig } from '../table-actions/table-actions.types';
import { NpaId } from '@circe/core';

export class NpaTableActionsConfiguration<T> {

  public actionsType: NpaTableActionType;
  public columnWidth: number;
  public group: boolean;
  public showOnHover: boolean;
  public hideColumn: boolean;
  public defaultActionId: NpaId;
  public actions: NpaActionConfig<T>[] | NpaActionConfigSource<T>;
  public dropdownConfig: NpaDropdownConfig;

  private _defaultConfiguration: NpaTableActionsConfigurationModel<T> = {
    dropdownConfig: {
      elementReference: ''
    },
    actionsType: 'link',
    columnWidth: 5,
    showOnHover: false,
    group: true,
    hideColumn: false,
    defaultActionId: ''
  };

  constructor(configModel?: NpaTableActionsConfigurationModel<T>) {
    this._processConfiguration(typeof configModel === 'object' ?
      { ...this._defaultConfiguration, ...configModel } : this._defaultConfiguration);
  }

  private _processConfiguration(config: NpaTableActionsConfigurationModel<T>): void {
    if ('dropdownConfig' in config) {
      this.dropdownConfig = {
        ...this.dropdownConfig,
        ...config.dropdownConfig
      };
    }

    if ('actionsType' in config) {
      this.actionsType = config.actionsType;
    }

    if ('columnWidth' in config) {
      this.columnWidth = config.columnWidth;
    }

    if ('group' in config) {
      this.group = config.group;
    }

    if ('hideColumn' in config) {
      this.hideColumn = config.hideColumn;
    }

    if ('showOnHover' in config) {
      this.showOnHover = config.showOnHover;
    }

    if ('actions' in config) {
      this.actions = config.actions;
    }

    if ('defaultActionId' in config) {
      this.defaultActionId = config.defaultActionId;
    }

    if (this.group && !this.dropdownConfig?.elementRelative) {
      throw new Error('If actions are grouped, an elementRelative for dropdown config is required.');
    }

    if (config.actions && !this.group && !this.actionsType) {
      throw new Error('You must provide a type for actions.');
    }
  }
}
